import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import Select, { MultiValue } from 'react-select'
import { optionsSupportSelect } from '@/app/utils/supportCategoryEnum'
import { FilterFormData } from './FilterReports'
import { OptionType } from '@/app/utils/optionSelectType'
import { FilterSelectStyle } from '@/view/components/BasicFilter/FilterSelectStyle'

export default function SupportType() {
  const {
    setValue,
    formState: { errors },
    getValues,
  } = useFormContext<FilterFormData>()
  const [opt, setOpt] = useState<MultiValue<OptionType>>([])

  const fieldValue = getValues('supportType')
  useEffect(() => {
    if (!fieldValue) setOpt([])
    else
      setOpt(
        optionsSupportSelect.filter(({ value }) =>
          fieldValue?.includes(value),
        ) || [],
      )
  }, [fieldValue])

  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  })

  return (
    <div className="space-y-2">
      <h3 className="font-medium text-black04">Tipo</h3>
      <Select
        options={optionsSupportSelect}
        isMulti
        onChange={(d) => {
          const values = d?.map(({ value }) => value) ?? undefined
          setValue('supportType', values as unknown as string)
          setOpt(d)
        }}
        value={opt}
        placeholder="Selecione o(s) tipo(s)"
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator,
        }}
      />
      {errors.supportType?.message}
    </div>
  )
}
